import { Dialog, DialogContent, DialogTitle, Grid, Tooltip } from "@mui/material";
import { CellClickedEvent, ColDef, ICellRendererParams, ValueFormatterParams, ValueGetterParams } from "ag-grid-community";
import React, { useEffect, useState } from "react";
import PullToRefresh from "react-simple-pull-to-refresh";
import { LoadContacts, LoadGroupContactsDeletion, LoadGroups } from "../../actions";
import { setHeaderCount, setHeaderTitle, setRefreshHandler, setSelectedCount } from "../../helpers/header.helper";
import setToast from "../../helpers/toaster.helper";
import { AddGroupIcon, BackIcon, BackMobileIcon, CancelIcon, DuplicateIcon, EditIcon, GroupInfoIcon, MultiSelectCrossIcon, MultiSelectDeleteIcon, MultiSelectDuplicateIcon, MultiSelectSendIcon, MultiSelectShareIcon, SendIcon, ShareGroupIcon, TrashIcon } from "../../icon";
import { Contact, Group } from "../../models/conversations";
import { PhoneNumberModel, PhoneNumberStatus } from "../../models/phone-number.model";
import { ProfileModel } from "../../models/profile.model";
import { GroupContactService } from "../../services/GroupContactService";
import { UtilityService } from "../../services/UtilityService";
import SendMessage from "../conversations/send-message-component";
import ContactInformation from "../shared/contact-details.component";
import ConfirmDialog from "../shared/confirm-dialog.component";
import { ActionLabels, DialogHeaders, GroupsMassAction, ToasterTexts, appNote, buttonLabels, emptyLabels, pageTitles, validationsMessages } from "../shared/constants";
import { validateForm } from "../shared/form-validation";
import GridComponent from "../shared/grid";
import { MenuItemRenderer } from "../shared/grid/actionsMenuItemRendrer";
import { ActionsRenderer } from "../shared/grid/actionsRenderer";
import { AvatarRenderer } from "../shared/grid/avatarRenderer";
import { dateComparator } from "../shared/grid/grid.services";
import PageHeaderComponent from "../shared/page-header.component";
import SelectPhoneNumbers from "../shared/select-phonenumbers/select-phonenumbers.component";
import { ToasterType } from "../shared/toaster/toaster.model";
import EditGroupComponent from "./edit-group.component";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors'
import { UserService } from "../../services/UserService";

interface IProps { }

const GroupsComponent = (props: IProps) => {
    const dispatch = useDispatch()
    const Groups: Group[] = useSelector(selector.groups);
    const Contacts: Contact[] = useSelector(selector.contacts);
    const LoadingGroups: boolean = useSelector(selector.loadingGroups);
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const IsDarkMode: boolean = useSelector(selector.isDarkMode);
    const CurrentUser: ProfileModel = UserService.getCurrentUserFromLocalStorage();
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers);
    const [openSendMessage, setOpenSendMessage] = useState<boolean>(false);
    const [selectedGroup, setSelectedGroup] = useState<Group>();
    const [addNewGroup, setAddNewGroup] = useState<boolean>(false);
    const [showEditGroupDialog, setShowEditGroupDialog] = useState<boolean>(false);
    const [showContacts, setShowContacts] = useState<boolean>(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);
    const [confirmDialogDescription, setConfirmDialogDescription] = useState<string>("");
    const [confirmButtonName, setConfirmButtonName] = useState<string>("");
    const [showRowMenu, setShowRowMenu] = useState<boolean>(false);
    const [showEditGroupPage, setShowEditGroupPage] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [checkedGroups, setCheckedGroups] = useState<Group[]>();
    const [errors, setErrors] = useState({ NewGroupName: "" });
    const [openMassAction, setOpenMassAction] = useState<boolean>(false);
    const [openShareGroup, setOpenShareGroup] = useState<boolean>(false);
    const [shareGroupLoading, setShareGroupLoading] = useState<boolean>(false);
    const [gridApi, setGridApi] = useState<any>();
    const [showMultiActionButtons, setShowMultiActionButtons] = useState<boolean>(false);
    const [columnApi, SetColumnApi] = useState<any>(null)
    const [groupName, setGroupName] = useState<string>("")
    const [selectedGroupId, setSelectedGroupId] = useState<string>("")
    const [openGroupInfo, setOpenGroupInfo] = useState<boolean>(false)
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [clickedRowId, setClickedRowId] = useState<string>("")
    const [selectedGroupName, setSelectedGroupName] = useState<string>("")
    const [groupDeletionResponsRecived, setGroupDeletionResponsRecived] = useState<boolean>(false)
    const [groupDeletionResponsData, SetgroupDeletionResponsData] = useState<any>()
    const [contactsInGroup, setContactsInGroup] = useState<Contact[]>()
    const [searchValue, setSearchValue] = useState<any>("");

    const handleCheckboxChange = (isConfim) => {
        setIsChecked(isConfim);
    };

    const GroupsColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Group Name",
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.replaceSpacesWithNBSP(params?.data?.Name);
            },
            onCellClicked: (event: CellClickedEvent) => {
                !IsMobileDevice && openGroupInfoDialog(event.data)
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                const AvatarComponent = {
                    component: AvatarRenderer,
                    params: {
                        SetName: params.data.Name?.replace('-', ' '), ShowBadgeIcon: true,
                        HideAvatar: IsMobileDevice,
                    }
                }
                if (params.data) {
                    return AvatarComponent
                }
                return undefined
            },
            sort: IsMobileDevice ? 'desc' : null,
            headerCheckboxSelection: IsMobileDevice ? false : true,
            checkboxSelection: IsMobileDevice ? false : true,
            wrapText: IsMobileDevice ? true : false,
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            cellStyle: !IsMobileDevice ? { textOverflow: 'ellipsis', paddingTop: "5px" } : { display: "flex" },
            cellClass: !IsMobileDevice && "c-pointer",
            minWidth: IsMobileDevice ? null : 200
        },
        {
            field: "ContactsCount",
            headerName: "Contacts",
            wrapText: true,
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.ContactsCount
            },
            minWidth: 100,
            maxWidth: 180
        },
        {
            field: "TotalActiveContacts",
            headerName: "Active",
            wrapText: true,
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.TotalActiveContacts
            },
            minWidth: 100,
            maxWidth: 180
        },
        {
            field: "TotalBlockedContacts",
            headerName: "Blocked",
            wrapText: true,
            autoHeight: true,
            hide: IsMobileDevice,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.TotalBlockedContacts
            },
            minWidth: 150,
            maxWidth: 180
        },
        {
            field: "TotalUnsubscribedContacts",
            headerName: "Unsubscribed",
            wrapText: true,
            autoHeight: true,
            hide: IsMobileDevice,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.TotalUnsubscribedContacts
            },
            minWidth: 150,
            maxWidth: 180
        },
        {
            field: "CreatedDateTime",
            headerName: "Updated Date",
            valueFormatter: (params: ValueFormatterParams) => {
                return UtilityService.convertDateToDay(params.value).toString()
            },
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertDateToDay(params.data.CreatedDateTime).toString()
            },
            sort: !IsMobileDevice ? 'desc' : null,
            hide: IsMobileDevice,
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
            minWidth: 150,
            width: 150,
            maxWidth: 150,
            suppressSizeToFit: true
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params =>
                <ActionsRenderer
                    MenuData={getMenuActions(params.data)}
                    {...params}
                />,
            resizable: false,
            sortable: false,
            hide: IsMobileDevice,
        },
    ]

    const getMenuActions = (data: Group) => {
        return [
            {
                Name: ActionLabels.EDIT,
                Icon: EditIcon,
                OnClick: !IsMobileDevice ? () => editGroup(data as Group) : () => {
                    setContactsInGroup(data.Contacts);
                    setShowEditGroupPage(true);
                    closeMenu();
                },
            },
            {
                Name: ActionLabels.VIEW_GROUP_INFO,
                Icon: GroupInfoIcon,
                OnClick: (e?: any) => {
                    setContactsInGroup(data.Contacts);
                    setSelectedGroup(data);
                    setOpenGroupInfo(true)
                },
            },
            {
                Name: ActionLabels.BRODCAST_MESSAGE,
                Icon: SendIcon,
                Hide: !(data as Group)?.ContactsCount,
                OnClick: () => sendGroupMessage(data as Group),
            },
            {
                Name: ActionLabels.SHARE_THIS_GROUP,
                Icon: ShareGroupIcon,
                Hide: !(data as Group)?.ContactsCount,
                OnClick: () => shareGroup(data as Group),
            },
            {
                Name: ActionLabels.DUPLICATE,
                Icon: DuplicateIcon,
                OnClick: () => openDuplicateConfirmDialog(data as Group),
            },
            {
                Name: ActionLabels.DELETE,
                Icon: TrashIcon,
                OnClick: () => {
                    openDeleteConfirmDialog(data.ID);
                },
            },
        ]
    }


    const openDeleteConfirmDialog = (id: string) => {
        setIsLoading(false);
        setShowConfirmDialog(true);
        setConfirmDialogDescription(appNote.GROUP_DELETE);
        setConfirmButtonName(buttonLabels.DELETE);
        closeMenu();
        setClickedRowId(id);
    }

    const deleteGroup = (id: string) => {

        setIsLoading(true);

        let name = Groups?.find((x) => x.ID === id)?.Name || "";
        let checked = !!Groups?.find((x) => x.ID === id)?.Contacts?.length && isChecked
        GroupContactService.deleteGroup(id, checked).then((res) => {

            LoadGroupContactsDeletion(dispatch, res.data)
            SetgroupDeletionResponsData(res.data)
            setSelectedGroupName(name)
            if (res.data.totalContactsCount === 0) {
                setGroupDeletionResponsRecived(false)
                setShowConfirmDialog(false)
            }
            else {
                setGroupDeletionResponsRecived(true)
            }

            if (!checked || res.data?.deletedContactsCount === 0) {
                setToast(
                    ToasterTexts.GROUP_DELETE_SUCCESS.replace("<Name>", name),
                    ToasterType.SUCCESS
                );
                LoadGroups(dispatch)
            }

            setIsLoading(false);
            setCheckedGroups([])
            clearSelection();
            // setClickedRowId('');
        });
    }

    const editGroup = (data?: Group) => {
        setSelectedGroup(data);
        setShowEditGroupDialog(true);
    }

    const sendGroupMessage = (data?: Group) => {
        setOpenSendMessage(true);
        setSelectedGroup(data);
    }

    const shareGroup = (data?: Group) => {
        setOpenShareGroup(true);
        setSelectedGroup(data);
        setGroupName(data?.Name);
        setSelectedGroupId(data?.ID);
    }

    const openDuplicateConfirmDialog = (data?: Group) => {
        closeMenu()
        let Text = appNote.MASS_ACTION_TEXT.replace('<action>', GroupsMassAction.DUPLICATE).replace('<name>', GroupsMassAction.GROUP);
        setSelectedGroup(data);
        setShowConfirmDialog(true);
        setConfirmDialogDescription(Text);
        setConfirmButtonName(buttonLabels.DUPLICATE);
        setIsLoading(false);
    }

    const closeMenu = () => {
        setShowRowMenu(false);
    };

    const getGridTitle = () => {
        if (showMultiActionButtons) {
            if (checkedGroups && checkedGroups.length > 1) {
                return checkedGroups.length + " Items selected";
            }
            else if (checkedGroups && checkedGroups.length === 1) {
                return "1 Item selected";
            }
        }
        else {
            if (Groups?.length === 1) {
                return "1 Group"
            }
            else {
                return Groups?.length + " " + pageTitles.GROUPS
            }
        }
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        SetColumnApi(params.columnApi)
    }

    const onSelectionChanged = () => {
        let SelectedGroups: Group[] = gridApi.getSelectedRows()
        if (gridApi && SelectedGroups.length > 0) {
            setShowMultiActionButtons(true);
            setCheckedGroups(SelectedGroups);
            setSelectedCount(SelectedGroups.length)
        }
        else {
            setShowMultiActionButtons(false);
            setCheckedGroups([]);
            setSelectedCount(SelectedGroups.length)
        }
    }

    const globalSearch = (e: any) => {
        setSearchValue(e.target.value)
        gridApi.setQuickFilter(e.target.value)
    };

    const clearSelection = () => {
        if (!!gridApi && !!checkedGroups?.length)
            gridApi.deselectAll();
    }
    const addGroup = () => {
        setAddNewGroup(true);
        setShowContacts(false);
        setShowEditGroupPage(true);
        setSelectedGroup(undefined);

    }

    const multipleSendmessage = () => {
        setOpenSendMessage(true);
    }

    useEffect(() => {
        if (Contacts?.length === 0) {
            LoadContacts(dispatch);
            LoadGroups(dispatch);
            setHeaderCount(Groups?.length || 0)
        }
        if (Groups?.length === 0 && !LoadingGroups) {
            LoadGroups(dispatch);
        }
        return () => {
            setSelectedCount(0)
        }
    }, [])

    useEffect(() => {
        setSelectedCount(0)
        setHeaderCount(Groups?.length || 0)

        return () => {
            setSelectedCount(0)
            setHeaderCount(Groups?.length || 0)
        }
    }, [Groups])


    useEffect(() => {
        setHeaderTitle(pageTitles.GROUPS);
        setHeaderCount(Groups?.length || 0)
        setRefreshHandler(gridRefresh)
        return setHeaderTitle
    }, [gridApi, columnApi])


    const gridRefresh = () => {
        LoadGroups(dispatch);
        if (!!columnApi) {
            columnApi.resetColumnState()
        }

        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
        }
        setCheckedGroups([]);
        setShowMultiActionButtons(false);
        gridApi.deselectAll();
    }


    const closeNewGroup = () => {
        setAddNewGroup(false);
        setSelectedGroup(undefined);
    };

    const closeSendMessage = (success?: boolean) => {
        setOpenSendMessage(false);
        setSelectedGroup(undefined);
        if (success) {
            clearSelection();
            setCheckedGroups([]);
        }
    };

    const openMassActionConfirmDialog = (action: string) => {
        let text = action === GroupsMassAction.DELETE ? (checkedGroups?.length > 1 ? appNote.GROUPS_DELETE : appNote.GROUP_DELETE) : appNote.MASS_ACTION_TEXT.replace('<action>', GroupsMassAction.DUPLICATE).replace('<name>', checkedGroups?.length > 1 ? pageTitles.GROUPS.toLocaleLowerCase() : GroupsMassAction.GROUP)
        setOpenMassAction(true);
        setConfirmDialogDescription(text);
        setConfirmButtonName(action);
        setIsLoading(false);
    }

    const closeEditGroup = (flag: boolean) => {
        setShowEditGroupPage(false);
        setShowEditGroupDialog(false);
        setShowContacts(false)
        setSelectedGroup(undefined);
    }

    const closeMassActionConfirmDialog = (isConfim: boolean) => {
        if (!!isConfim) {
            let NameError = false;
            if (checkedGroups?.length > 0) {
                const data = checkedGroups?.map((item) => {
                    let duplicateGroupName = "";
                    let index = -1;
                    let iteration = 0;
                    do {
                        duplicateGroupName = iteration
                            ? `${item.Name} - Copy (${iteration})`
                            : `${item.Name} - Copy`;
                        index = Groups?.findIndex((x) => x.Name === duplicateGroupName);
                        iteration++;
                    } while (index >= 0);

                    if (!validateForm({ NewGroupName: duplicateGroupName }, (errors) => {
                        if (errors.NewGroupName && confirmButtonName === GroupsMassAction.DUPLICATE) {
                            NameError = true;
                        }
                    })) {
                        return item.ID;
                    }

                    return confirmButtonName === GroupsMassAction.DUPLICATE ? `${item.ID}#${duplicateGroupName
                        }` : item.ID
                })

                if (NameError) {
                    setToast(
                        ToasterTexts.GROUP_NAME_MAX_LENGTH.replace(
                            "<Name>",
                            selectedGroup?.Name || ""
                        ),
                        ToasterType.DANGER
                    )

                    return setOpenMassAction(false);

                }
                setIsLoading(true);
                let checkedGroupIDs = checkedGroups?.map(x => x?.ID)
                GroupContactService.groupsMassAction(confirmButtonName, data).then((res: any) => {
                    LoadGroups(dispatch);
                    confirmButtonName === GroupsMassAction.DELETE ? setToast(ToasterTexts.MULTIPLE_GROUP_DELETE_SUCCESS, ToasterType.SUCCESS) : setToast(ToasterTexts.MULTIPLE_GROUP_DUPLICATE_SUCCESS, ToasterType.SUCCESS)
                    setOpenMassAction(false);
                    setConfirmButtonName("");
                    setIsLoading(false);
                    setCheckedGroups([]);
                    setShowMultiActionButtons(false);
                    clearSelection();
                    LoadGroups(dispatch);
                }).catch(err => {
                    if (err.response.status === 404 || err.response.status === 400 || err.response.status === 500) {
                        setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                        setIsLoading(false);
                    }
                })
            }
        } else {
            setOpenMassAction(false);
            setConfirmButtonName("");
            setIsLoading(false);
        }
    };

    const closeNewGroupMobile = () => {
        closeNewGroup()
        setShowContacts(true);
        setShowEditGroupPage(false);
        closeMenu();
        clearSelection();
    }

    const handleConfirmDialogClose = (isConfim: boolean) => {
        if (!!isConfim && confirmButtonName === "Duplicate") {
            handleDuplicate();
            setShowConfirmDialog(false);
            clearSelection();
        }

        if (!!isConfim && confirmButtonName !== "Duplicate") {
            deleteGroup(clickedRowId)
            if (!isChecked) {
                setShowConfirmDialog(false);
            }
        }
        if (!isConfim) {
            SetgroupDeletionResponsData([])
            setShowConfirmDialog(false);
            setConfirmDialogDescription("")
            setGroupDeletionResponsRecived(false)
        }
    };

    const handleDuplicate = () => {
        setIsLoading(true);
        setShowRowMenu(false);
        let duplicateGroupName = "";
        let index = -1;
        let iteration = 0;
        do {
            duplicateGroupName = iteration
                ? `${selectedGroup?.Name} - Copy (${iteration})`
                : `${selectedGroup?.Name} - Copy`;
            index = Groups?.findIndex((x) => x.Name === duplicateGroupName);
            iteration++;
        } while (index >= 0);

        if (!validateForm({ NewGroupName: duplicateGroupName }, (errors) => {
            setErrors({ NewGroupName: errors["NewGroupName"] })

        })) {
            setToast(
                ToasterTexts.GROUP_NAME_MAX_LENGTH.replace(
                    "<Name>",
                    selectedGroup?.Name || ""
                ),
                ToasterType.DANGER
            )
            setIsLoading(false);
            setErrors({ NewGroupName: "" })
            setSelectedGroup(undefined)
        }
        else {
            GroupContactService.createGroup({
                name: duplicateGroupName,
                contacts:
                    selectedGroup?.Contacts?.map((x) => {
                        return { contactId: x.ID };
                    }) || [],
            }).then(
                (res) => {
                    if (res.status === 200) {

                        setIsLoading(false);
                        setCheckedGroups([]);
                        setToast(
                            ToasterTexts.GROUP_DUPLICATE_SUCCESS.replace(
                                "<Name>",
                                selectedGroup?.Name || ""
                            ),
                            ToasterType.SUCCESS
                        );
                    }
                },
                () => {
                    setIsLoading(false);
                    setCheckedGroups([]);
                    setToast(
                        ToasterTexts.GROUP_DUPLICATE_FAILED.replace(
                            "<Name>",
                            selectedGroup?.Name || ""
                        ),
                        ToasterType.DANGER
                    );
                }
            );
        }
    };

    const pullToRefresh = () =>
        new Promise((resolve) => resolve).then(() =>
            LoadGroups(dispatch)
        );


    const handleRowClick = (row?: Group) => {
        if (IsMobileDevice) {
            setShowRowMenu(true);
            setSelectedGroup(row as Group)
        }
    }

    const handleSharethisGroup = (phoneNumberIDs: string[]) => {
        let GroupName = `${groupName} - Shared`
        if (!validateForm({ NewGroupName: GroupName }, (errors) => {
            setErrors({ NewGroupName: errors["NewGroupName"] });
        })) {
            setIsLoading(false);
            setErrors({ NewGroupName: validationsMessages.SHARE_GROUP_NAME_MAX_LENGTH });
        } else {
            setShareGroupLoading(true);
            GroupContactService.shareGroup(selectedGroupId, phoneNumberIDs, GroupName).then(res => {
                setToast(ToasterTexts.GROUP_SHARED_SUCCESSFULLY.replace('<groupName>', groupName), ToasterType.SUCCESS)
                setOpenShareGroup(false);
                setShareGroupLoading(false);
                setSelectedGroup(undefined);
            }).catch(error => {
                if (error.response.status === 400 && error.response.data.code === "DUPLICATE") {
                    setToast(error.response.data.message, ToasterType.DANGER)
                    setOpenShareGroup(false);
                    setShareGroupLoading(false);
                    setSelectedGroup(undefined);
                }
                else if (error.response.status === 500) {
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                    setOpenShareGroup(false);
                    setShareGroupLoading(false);
                    setSelectedGroup(undefined);
                }
            })
        }
    }

    const closeShareGroup = () => {
        setOpenShareGroup(false);
        setErrors({ ...errors, NewGroupName: "" })
        setSelectedGroupId("")
    }

    const openMassActionShareGroupDialog = () => {
        setOpenShareGroup(true);
        setGroupName(checkedGroups[0]?.Name)
        setSelectedGroupId(checkedGroups[0]?.ID)
    }

    const openGroupInfoDialog = (group: Group) => {
        setOpenGroupInfo(true);
        setSelectedGroup(group)
        setContactsInGroup(group.Contacts)
    }
    const closeGroupInfoPopup = () => {
        setOpenGroupInfo(null);
        setSelectedGroup(undefined)
        setContactsInGroup([])
    }

    const unsubscribeContactsCount = (GroupIDs?: string[]) => {
        let groups = Groups?.filter(x => GroupIDs?.includes(x.ID));
        let contactsFromGroups = groups?.flatMap(x => x.Contacts);
        return contactsFromGroups?.filter((x, i) => contactsFromGroups?.findIndex(y => y?.ID === x?.ID) === i)?.filter(x => x.IsUnsubscribed).length
    }

    const delterHandler = (checkedGroups: Group[]) => {
        if (checkedGroups?.length === 1) {
            setIsLoading(false);
            setShowConfirmDialog(true);
            setConfirmDialogDescription(appNote.GROUP_DELETE);
            setConfirmButtonName(buttonLabels.DELETE);
            setClickedRowId(checkedGroups[0]?.ID || "")
            closeMenu();
        }
        else {
            openMassActionConfirmDialog(GroupsMassAction.DELETE)
        }
    }

    const checkIsCampaign = (): boolean => {
        let isCampaign: boolean;
        if (selectedGroup?.ID) {
            isCampaign = (selectedGroup?.TotalActiveContacts + selectedGroup?.TotalBlockedContacts) > 1
        } else {
            let allConatctsInGroups = checkedGroups?.flatMap(x => x.Contacts)
            let unsubscribeContactsCount = allConatctsInGroups
                ?.filter((x, i) => allConatctsInGroups?.findIndex(y => y?.ID === x?.ID) === i)
                ?.filter(x => x.IsUnsubscribed).length
            isCampaign = (allConatctsInGroups?.length - unsubscribeContactsCount) > 1
        }
        return isCampaign
    }

    const handleCellRowClick = (e: any, row: any) => {
        if (!IsMobileDevice && e.colDef.field !== "Action" && e.colDef.field !== "Name") {
            editGroup(row)
            setOpenGroupInfo(false)
        }
    }

    return (<>
        {IsMobileDevice && openSendMessage ? (
            <SendMessage
                IsCampaign={checkIsCampaign()}
                open={openSendMessage}
                GroupIDs={selectedGroup?.ID ? [selectedGroup?.ID] : checkedGroups?.map((x) => x.ID)}
                handleClose={closeSendMessage}
                UnsubscribeContactCount={unsubscribeContactsCount(selectedGroup?.ID ? [selectedGroup?.ID] : checkedGroups?.map((x) => x.ID))}
            />
        ) : (openGroupInfo && IsMobileDevice) ?
            <ContactInformation
                openContactInfo={openGroupInfo}
                handleContactClose={closeGroupInfoPopup}
                IsMobileDevice={IsMobileDevice}
                SelectedGroup={contactsInGroup}
                groupInfo={true}
                GroupName={selectedGroup.Name}
            /> : showEditGroupPage && selectedGroup && IsMobileDevice ?
                <div className="paper-background h-p-100">
                    <div className="box-shadow-primary-header-shadow bg-color-secondary p-2">
                        <div className="h1 d-flex">
                            <BackMobileIcon
                                className={"c-pointer pr-2 my-auto"}
                                onClick={() => {
                                    showContacts
                                        ? setShowContacts(false)
                                        : closeEditGroup(false);
                                }}
                            />
                            <span className={"my-auto"}>  Edit Group: {!!selectedGroup?.Name && UtilityService.trimMessage(selectedGroup?.Name, 13)}</span>
                        </div>
                    </div>
                    <div className={`${IsMobileDevice ? "" : "o-hidden"}`}>
                        <EditGroupComponent
                            {...selectedGroup}
                            ContactsInGroup={selectedGroup?.Contacts || []}
                            Contacts={Contacts}
                            closeHandler={closeEditGroup}
                            IsMobileDevice={IsMobileDevice}
                            clearSelection={clearSelection}
                        ></EditGroupComponent>
                    </div>
                </div>
                :
                addNewGroup && IsMobileDevice && !selectedGroup ?
                    <div className={` ${IsDarkMode ? "bg-color-primary-background" : "paper-background"}  h-p-100`}>
                        <div className={`box-shadow-primary-header-shadow  p-2 ${IsDarkMode ? "bg-color-primary-background" : "bg-color-secondary"} `}>
                            <div className="h1 d-flex">
                                <BackMobileIcon
                                    className={"c-pointer pr-2 my-auto"}
                                    onClick={() => {
                                        closeNewGroupMobile()
                                    }}
                                />
                                <span className={"my-auto"}> {DialogHeaders.ADD_GROUP} </span>
                            </div>
                        </div>
                        <div className={`${IsMobileDevice ? "" : "o-hidden"}`}>
                            <EditGroupComponent
                                {...selectedGroup}
                                ContactsInGroup={
                                    []
                                }
                                Contacts={Contacts}
                                closeHandler={closeNewGroupMobile}
                                IsMobileDevice={IsMobileDevice}
                                clearSelection={clearSelection}
                            ></EditGroupComponent>
                        </div>
                    </div>
                    :
                    <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh}>
                        <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                            {!IsMobileDevice ?
                                <div className="d-flex bg-color-secondary w-fill justify-between flex-direction">
                                    <PageHeaderComponent
                                        Reload={() => LoadGroups(dispatch)}
                                        GridTitle={""}
                                        Count={Groups.length}
                                        Actions={[
                                            {
                                                OnClick: () => addGroup(),
                                                ButtonLabel: buttonLabels.ADD_GROUP,
                                                Icon: AddGroupIcon,
                                                ClassName: "mr-2",
                                                Variant: "primary-btn",
                                            },
                                        ]}
                                        ShowFilterIcon={false}
                                        searchValue={searchValue}
                                        onSearch={(e) => globalSearch(e)}
                                        PlaceHolder={"Search ..."}
                                        ShowMultiActionButtons={showMultiActionButtons}
                                        MultiActionButtons={[
                                            {
                                                Name: ActionLabels.SEND,
                                                Variant: "primary",
                                                Hide: (checkedGroups?.length > 100 || !checkedGroups?.length || checkedGroups?.every(x => x.ContactsCount === 0)),
                                                ClassName: "mr-1",
                                                Icon: MultiSelectSendIcon,
                                                OnClick: () => multipleSendmessage()
                                            },
                                            {
                                                Name: buttonLabels.DUPLICATE,
                                                Variant: "primary",
                                                Hide: !(checkedGroups?.length === 1),
                                                ClassName: "mr-1",
                                                Icon: MultiSelectDuplicateIcon,
                                                OnClick: () => openDuplicateConfirmDialog(checkedGroups[0])
                                            },
                                            {
                                                Name: ActionLabels.SHARE,
                                                ClassName: "mr-1",
                                                Icon: MultiSelectShareIcon,
                                                Variant: "primary",
                                                Hide: !(checkedGroups?.find(x => x.ContactsCount) && checkedGroups?.length === 1),
                                                OnClick: () => openMassActionShareGroupDialog()
                                            },
                                            {
                                                Name: ActionLabels.DELETE,
                                                Variant: !!checkedGroups?.length ? "primary" : "disabled",
                                                ClassName: "mr-1",
                                                Icon: MultiSelectDeleteIcon,
                                                OnClick: () => delterHandler(checkedGroups)
                                            },
                                            {
                                                Name: ActionLabels.CLEAR_SELECTION,
                                                Variant: "text",
                                                ClassName: "p-0 mr-1 w-space",
                                                Icon: MultiSelectCrossIcon,
                                                OnClick: () => clearSelection(),
                                            }
                                        ]}
                                    />

                                </div> :
                                <Grid>
                                    <PageHeaderComponent
                                        Reload={() => LoadGroups(dispatch)}
                                        GridTitle={getGridTitle()}
                                        Count={Groups.length}
                                        Actions={[
                                            {
                                                OnClick: () => addGroup(),
                                                ButtonLabel: buttonLabels.ADD_GROUP,
                                                ClassName: "mr-2",
                                                Variant: "primary-btn",
                                            },
                                        ]}
                                        ShowFilterIcon={false}
                                        onSearch={(e) => globalSearch(e)}
                                        PlaceHolder={"Search ..."}
                                    />
                                </Grid>
                            }
                            <GridComponent
                                ColumnDefs={GroupsColoumnDefs}
                                RowData={Groups}
                                OnGridReady={onGridReady}
                                OnSelectionChanged={onSelectionChanged}
                                IsPaginationEnabled={!IsMobileDevice}
                                OnGridRowClick={handleRowClick}
                                EmptyLabel={emptyLabels.GROUPS}
                                LockVisible={IsMobileDevice}
                                OnGridCellRowClick={handleCellRowClick}
                                ShowRowPointer={true}
                            />
                            {IsMobileDevice && !!showRowMenu && (
                                <Dialog
                                    fullWidth
                                    maxWidth="sm"
                                    onClose={closeMenu}
                                    aria-labelledby="responsive-dialog-title"
                                    open={true}
                                    classes={{ paper: `br-2 ${IsDarkMode ? "" : "dialogue-shadow"}  w-p-70 bg-color-menu-bg` }}
                                >
                                    <DialogTitle className="pb-1">
                                        <div
                                            className="h1 color-display-title d-flex"
                                            id="customized-dialog-title"
                                        >
                                            {!!selectedGroup?.Name && UtilityService.trimMessage(selectedGroup?.Name, 12)}
                                            <span className="ml-auto">
                                                <Tooltip title="Close" placement="bottom">
                                                    <CancelIcon
                                                        className={"c-pointer"}
                                                        onClick={closeMenu}
                                                    />
                                                </Tooltip>
                                            </span>
                                        </div>
                                    </DialogTitle>
                                    <DialogContent className={"mln-1 o-hidden"}>
                                        <MenuItemRenderer MenuData={getMenuActions(selectedGroup)} OnClick={closeMenu} />
                                    </DialogContent>
                                </Dialog>
                            )}
                            {
                                openSendMessage && !IsMobileDevice &&
                                <SendMessage
                                    open={openSendMessage}
                                    GroupIDs={selectedGroup?.ID ? [selectedGroup?.ID] : checkedGroups?.map((x) => x.ID)}
                                    handleClose={closeSendMessage}
                                    IsCampaign={checkIsCampaign()}
                                    UnsubscribeContactCount={unsubscribeContactsCount(selectedGroup?.ID ? [selectedGroup?.ID] : checkedGroups?.map((x) => x.ID))}
                                />
                            }
                            {
                                addNewGroup && !IsMobileDevice && !selectedGroup &&
                                <Dialog
                                    // onClose={closeNewGroup}
                                    aria-labelledby="responsive-dialog-title"
                                    open={true}
                                    BackdropProps={IsMobileDevice ? {} : {
                                        style: { backgroundColor: "transparent" },
                                    }}
                                    className={`${IsDarkMode ? "" : "dialogue-shadow"}  h-p-100`}

                                    disableEscapeKeyDown
                                    PaperProps={{
                                        style: {
                                            height: "75vh",
                                            width: "100vh",
                                        },
                                    }}
                                >
                                    <DialogTitle className={`p-2 ${IsDarkMode ? "bg-color-sidebar-bg" : ""}`}>
                                        <div className={`${IsMobileDevice ? 'h1' : 'h2-regular'} ${IsDarkMode ? "" : "color-display-title"} d-flex ml-1`} id="customized-dialog-title">
                                            {DialogHeaders.ADD_GROUP}
                                            <Tooltip title="Close" placement="bottom">
                                                <span className="ml-auto mr-1">
                                                    <CancelIcon
                                                        className={"c-pointer"}
                                                        onClick={closeNewGroup}
                                                    />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </DialogTitle>
                                    <div className={"bb-primary-background-pink-4 mx-2"}></div>
                                    <EditGroupComponent
                                        {...selectedGroup}
                                        closeHandler={closeNewGroup}
                                        IsMobileDevice={IsMobileDevice}
                                        clearSelection={clearSelection}
                                    ></EditGroupComponent>
                                </Dialog>
                            }
                            {
                                showEditGroupDialog && selectedGroup &&
                                <Dialog
                                    fullWidth
                                    maxWidth="sm"
                                    // onClose={closeEditGroup}
                                    aria-labelledby="responsive-dialog-title"
                                    open={true}
                                    BackdropProps={{
                                        style: { backgroundColor: "transparent" },
                                    }}
                                    className={`${IsDarkMode ? "" : "dialogue-shadow"} `}

                                    disableEscapeKeyDown
                                    PaperProps={{
                                        style: {
                                            height: "75vh",
                                            width: "100vh",
                                        },
                                    }}
                                >
                                    <DialogTitle className={`dialog-header ${IsDarkMode ? "bg-color-sidebar-bg" : "dialogue-shadow"}`}>
                                        <div className="h3 d-flex" id="customized-dialog-title">
                                            {showContacts && (
                                                <BackIcon
                                                    className={
                                                        "c-pointer mln-1 p-1 icon-primary mr-1"
                                                    }
                                                    onClick={() => {
                                                        setShowContacts(false);
                                                    }}
                                                />
                                            )}
                                            <span className="my-auto">
                                                Edit Group: {selectedGroup?.Name}
                                            </span>
                                            <Tooltip title="Close" placement="bottom">
                                                <span className="ml-auto my-auto d-flex">
                                                    <CancelIcon
                                                        className={"c-pointer"}
                                                        onClick={() => closeEditGroup(false)}
                                                    />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </DialogTitle>
                                    <div className={"bb-primary-background-pink-4 mx-2"}></div>
                                    <EditGroupComponent
                                        {...selectedGroup}
                                        ContactsInGroup={selectedGroup?.Contacts || []}
                                        Contacts={Contacts}
                                        closeHandler={closeEditGroup}
                                        IsMobileDevice={IsMobileDevice}
                                        clearSelection={clearSelection}
                                    ></EditGroupComponent>
                                </Dialog>
                            }

                            {
                                openShareGroup && <SelectPhoneNumbers
                                    Title={`${ActionLabels.SHARE_THIS_GROUP} - ${IsMobileDevice ? groupName && UtilityService.trimMessage(groupName, 13) : groupName}`}
                                    OnClose={() => closeShareGroup()}
                                    Show={openShareGroup}
                                    HandleSubmit={handleSharethisGroup}
                                    Loading={shareGroupLoading}
                                    ButtonName={buttonLabels.SHARE}
                                    Error={errors.NewGroupName}
                                    Options={PhoneNumbers?.filter((x: PhoneNumberModel) => x.OrganizationID === CurrentUser.OrgId && x.Status === PhoneNumberStatus.ACTIVE && CurrentUser.PhoneNumber !== x.PhoneNumber)}
                                />
                            }

                            {showConfirmDialog && <ConfirmDialog
                                onClose={handleConfirmDialogClose}
                                Show={showConfirmDialog}
                                Text={confirmDialogDescription}
                                ButtonName={confirmButtonName}
                                Loading={isLoading}
                                IsMobileDevice={IsMobileDevice}
                                HandleCheckbox={handleCheckboxChange}
                                ShowCheckBox={confirmButtonName === "Delete"}
                                ResponsRecived={groupDeletionResponsRecived}
                                GroupDeletionResponsData={groupDeletionResponsData}
                                Title={confirmButtonName === "Delete" ? groupDeletionResponsRecived ? `${IsMobileDevice ? UtilityService.trimMessage(selectedGroupName, 14) : selectedGroupName} - deleted successfully` : "Delete this group?" : ""}
                                CheckBoxText={"Also delete the contacts in this group"}
                                DeletedGroupName={selectedGroupName}
                            />}

                            {
                                openMassAction &&
                                <ConfirmDialog
                                    onClose={closeMassActionConfirmDialog}
                                    HandleCheckbox={handleCheckboxChange}
                                    Show={openMassAction}
                                    Text={confirmDialogDescription}
                                    ButtonName={confirmButtonName}
                                    Loading={isLoading}
                                    IsMobileDevice={IsMobileDevice}
                                />}

                            {
                                (openGroupInfo && !IsMobileDevice) &&
                                <div className={`contact-details w-60 r-p-45 t-20`}>
                                    <ContactInformation
                                        openContactInfo={openGroupInfo}
                                        handleContactClose={closeGroupInfoPopup}
                                        SelectedGroup={contactsInGroup}
                                        groupInfo={true}
                                        IsMobileDevice={false}
                                        GroupName={selectedGroup?.Name}
                                    />
                                </div>
                            }
                        </div>
                    </PullToRefresh>
        }
    </>
    )
}

export default GroupsComponent;
